import { render, staticRenderFns } from "./widget_layout.vue?vue&type=template&id=92b0fedc&scoped=true&lang=pug&"
import script from "./widget_layout.vue?vue&type=script&lang=js&"
export * from "./widget_layout.vue?vue&type=script&lang=js&"
import style0 from "./widget_layout.vue?vue&type=style&index=0&id=92b0fedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b0fedc",
  null
  
)

export default component.exports